<template>
  <el-tabs type="card" v-model="current" @tab-remove="handleRemove">
    <el-tab-pane label="换货单" name="list">
      <div class="search-container">
        <el-form ref="form" inline>
          <el-form-item label="单号" label-width="78px">
            <el-input v-model="queryParam.exchangeNo" clearable></el-input>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button type="primary" @click="list(1)">
              <el-icon><search /></el-icon>查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-container">
        <div class="table-header">
          <el-row :gutter="10">
            <el-col :span="10">
              <div class="table-title"><span></span>换货单列表</div>
            </el-col>
            <el-col :span="14">
              <div class="table-button-container">
                <el-button type="success" @click="showSave()" v-if="$permission.hasAuth([0])">
                  <el-icon><plus /></el-icon>新增换货单
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-table :data="orders" border>
          <el-table-column prop="createDate" label="时间"></el-table-column>
          <el-table-column prop="exchangeNo" label="单号"></el-table-column>
          <el-table-column prop="factoryCompanyName" label="门店名称"></el-table-column>
          <el-table-column label="原货品">
            <template #default="scope">
              <el-row :gutter="8" v-for="item in scope.row.srcExchangeGoodsItemVOS" :key="item.goodsSn">
                <el-col :span="16">
                  {{item.name}}
                </el-col>
                <el-col :span="8">
                  {{item.quantity + item.unit}}
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="新货品">
            <template #default="scope">
              <el-row :gutter="8" v-for="item in scope.row.newExchangeGoodsItemVOS" :key="item.goodsSn">
                <el-col :span="16">
                  {{item.name}}
                </el-col>
                <el-col :span="8">
                  {{item.quantity + item.unit}}
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template #default="scope">
              {{scope.row.status === 0 ? '待确认' : scope.row.status === 1 ? '待换货' : '已换货'}}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <el-link type="primary" href="javascript:;" v-if="$permission.hasAuth([1, 5]) && scope.row.status === 0"
                       @click="confirmTransfer(scope.row)">确认换货</el-link>
              <el-link type="primary" href="javascript:;" v-if="scope.row.status === 1" @click="confirmIn(scope.row)">确认收货</el-link>
              <el-link type="primary" href="javascript:;"
                       v-if="($permission.hasAuth([1, 5]) && scope.row.status !== 2) || (currentUser.type === 0 && scope.row.status === 0)"
                       @click="showSave(scope.row)">修改</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                       :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                       background
                       layout="sizes, prev, pager, next, total"></el-pagination>
      </div>
    </el-tab-pane>
    <el-tab-pane closable :label="!order.sn ? '新增换货单' : '修改换货单'" name="save" v-if="saveVisible">
      <el-form inline v-if="order.sn">
        <el-form-item label="单号" label-width="78px">
          {{order.exchangeNo}}
        </el-form-item>
        <el-form-item label="门店名称" label-width="78px">
          {{order.factoryCompanyName}}
        </el-form-item>
      </el-form>
      <div class="table-container">
        <div class="table-header">
          <el-row :gutter="10">
            <el-col :span="10">
              <div class="table-title"><span></span>原货品</div>
            </el-col>
            <el-col :span="14">
              <div class="table-button-container">
                <el-button type="success" @click="showAddOrg()">
                  <el-icon><plus /></el-icon>添加
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-table :data="order.srcExchangeGoodsItemVOS" border>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column label="数量">
            <template #default="scope">
              <el-input type="number" v-model="scope.row.quantity" placeholder="请输入数量">
                <template #append>{{scope.row.unit}}</template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <el-link type="danger" href="javascript:;" @click="del(0, scope.$index, scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="height: 18px;"></div>
      <div class="table-container">
        <div class="table-header">
          <el-row :gutter="10">
            <el-col :span="10">
              <div class="table-title"><span></span>新货品</div>
            </el-col>
            <el-col :span="14">
              <div class="table-button-container">
                <el-button type="success" @click="showAddNew()">
                  <el-icon><plus /></el-icon>添加
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-table :data="order.newExchangeGoodsItemVOS" border>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column label="数量">
            <template #default="scope">
              <el-input type="number" v-model="scope.row.quantity" placeholder="请输入数量">
                <template #append>{{scope.row.unit}}</template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <el-link type="danger" href="javascript:;" @click="del(1, scope.$index, scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-button type="primary" @click="save" style="margin-top: 12px;">确认</el-button>

      <el-dialog title="添加油品" v-model="addOrgVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="stock" ref="stock">
          <el-form-item label="油品" label-width="78px">
            <el-select v-model="currentStock" value-key="sn" @change="stock.quantity = currentStock.quantity">
              <el-option v-for="(item, index) in stocks" :key="index" :label="item.name" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数量" label-width="78px">
            <el-input type="number" v-model="stock.quantity" placeholder="请输入数量">
              <template #append>{{currentStock.unit ? currentStock.unit : '箱'}}</template>
            </el-input>
          </el-form-item>
          <el-button type="primary" @click="addOrg">确定</el-button>
        </el-form>
      </el-dialog>

      <el-dialog title="添加油品" v-model="addNewVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="oil" ref="oil">
          <el-form-item label="油品" label-width="78px">
            <el-select v-model="currentOil" value-key="sn">
              <el-option v-for="(item, index) in oils" :key="index" :label="item.name" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数量" label-width="78px">
            <el-input type="number" v-model="oil.quantity" placeholder="请输入数量">
              <template #append>{{currentOil.firstUnit ? currentOil.firstUnit : '箱'}}</template>
            </el-input>
          </el-form-item>
          <el-button type="primary" @click="addNew">确定</el-button>
        </el-form>
      </el-dialog>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "换货单",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      current: 'list',
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {},
      orders: [],
      saveVisible: false,
      order: {},
      addOrgVisible: false,
      stock: {},
      currentStock: {},
      stocks: [],
      addNewVisible: false,
      oil: {},
      currentOil: {},
      oils: []
    }
  },
  methods: {
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.store.shopTransferList(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        this.orders = response.data.data
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    handleRemove() {
      this.current = 'list'
      this.saveVisible = false
      this.order = {}
    },
    showSave(order) {
      this.saveVisible = true
      this.current = 'save'
      if (!order) {
        this.order = {
          factorySn: this.currentUser.sn,
          srcExchangeGoodsItemVOS: [],
          newExchangeGoodsItemVOS: []
        }
      } else {
        this.order = JSON.parse(JSON.stringify(order))
      }
    },
    save() {
      if (this.order.srcExchangeGoodsItemVOS.length <= 0) {
        this.$message.error('请选择原货品')
        return
      }
      const temp = this.order.srcExchangeGoodsItemVOS.find(item => Number(item.quantity) > item.stockQuantity)
      if (temp) {
        this.$message.error(temp.name + '数量大于库存数')
        return
      }
      if (this.order.newExchangeGoodsItemVOS.length <= 0) {
        this.$message.error('请选择新货品')
        return
      }
      const orgNum = this.order.srcExchangeGoodsItemVOS.reduce((total, item) => total + Number(item.quantity), 0)
      const newNum = this.order.newExchangeGoodsItemVOS.reduce((total, item) => total + Number(item.quantity), 0)
      if (orgNum !== newNum) {
        this.$message.error('原货品数量与新货品数量不一致')
        return
      }
      let param = {
        exchangeNo: this.order.exchangeNo,
        factorySn: this.order.factorySn,
        exchangeGoodsItemTOS: this.order.srcExchangeGoodsItemVOS.concat(this.order.newExchangeGoodsItemVOS)
      }
      if (!this.order.sn) {
        this.$apis.store.addShopTransfer(param).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.saveVisible = false
            this.current = 'list'
            this.list(1)
          }
        })
      } else {
        this.$apis.store.editShopTransfer(param).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.saveVisible = false
            this.current = 'list'
            this.list()
          }
        })
      }

    },
    confirmTransfer(order) {
      this.$confirm('确认允许此【' + order.exchangeNo + '】换货单？操作不可逆，请谨慎操作！', '换货确认',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        this.$apis.store.confirmShopTransfer(order.exchangeNo).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.list()
          }
        })
      }).catch(() => {

      })
    },
    confirmIn(order) {
      this.$confirm('确认此【' + order.exchangeNo + '】换货单已完成换货？操作不可逆，请谨慎操作！', '收货确认',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        this.$apis.store.completeShopTransfer(order.exchangeNo).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.list()
          }
        })
      }).catch(() => {

      })
    },
    showAddOrg() {
      this.addOrgVisible = true
      this.stock = {}
      this.currentStock = {}
      this.$apis.store.stockList(0, 99, {companySn: this.order.factorySn}).then(response => {
        let stocks = response.data.data
        if (stocks) {
          stocks = stocks.filter(item => item.type === 0)
        }
        this.stocks = stocks
      })
    },
    addOrg() {
      if (!this.currentStock.goodsSn) {
        this.$message.error('请选择油品')
        return
      }
      if (!this.stock.quantity) {
        this.$message.error('请输入数量')
        return
      }
      if (Number(this.stock.quantity) > this.currentStock.quantity) {
        this.$message.error('数量不能大于库存数')
        return
      }
      let temp = {
        name: this.currentStock.name,
        unit: this.currentStock.unit,
        stockQuantity: this.currentStock.quantity,
        goodsSn: this.currentStock.goodsSn,
        quantity: Number(this.stock.quantity),
        type: 0
      }
      const index = this.order.srcExchangeGoodsItemVOS.findIndex(item => item.goodsSn === temp.goodsSn)
      if (index >= 0) {
        this.order.srcExchangeGoodsItemVOS.splice(index, 1)
      }
      this.order.srcExchangeGoodsItemVOS.push(temp)
      this.addOrgVisible = false
    },
    showAddNew() {
      this.addNewVisible = true
      this.oil = {}
      this.currentOil = {}
    },
    addNew() {
      if (!this.currentOil.sn) {
        this.$message.error('请选择油品')
        return
      }
      if (!this.oil.quantity) {
        this.$message.error('请输入数量')
        return
      }
      let temp = {
        name: this.currentOil.name,
        unit: this.currentOil.firstUnit,
        goodsSn: this.currentOil.sn,
        quantity: Number(this.oil.quantity),
        type: 1
      }
      const index = this.order.newExchangeGoodsItemVOS.findIndex(item => item.goodsSn === temp.goodsSn)
      if (index >= 0) {
        this.order.newExchangeGoodsItemVOS.splice(index, 1)
      }
      this.order.newExchangeGoodsItemVOS.push(temp)
      this.addNewVisible = false
    },
    del(type, index, oil) {
      this.$confirm('确认删除【' + oil.name + '】？', '删除确认',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        if (type === 0) {
          this.order.srcExchangeGoodsItemVOS.splice(index, 1)
        } else if (type === 1) {
          this.order.newExchangeGoodsItemVOS.splice(index, 1)
        }
      }).catch(() => {

      })
    }
  },
  created() {
    if (this.currentUser.type === 0) {
      this.queryParam.factorySn = this.currentUser.sn
    } else if (this.currentUser.type === 1) {
      this.queryParam.agentSn = this.currentUser.sn
    } else if (this.currentUser.type === 5) {
      this.queryParam.agentSn = this.currentUser.agentSn
    }
    this.list()
    this.$apis.storeGoods.list(0, 99, {type: 0}).then(response => {
      this.oils = response.data.data
    })
  }
}
</script>

<style scoped>

</style>